import type { StoredSignals } from '../../data/signals';
import { getSyncStatus, runSync } from '../../data/sync';
import { pacificDateTime } from '../../logic/dates';
import { empty, btn, linkBtn } from '../../ui/components';
import { h } from '../../ui/dom';
import { OFFLINE_SIGNALS_ONLY } from '../../ui/labels';

export interface EmptyMirrorOptions {
  /** When the cached new-businesses list was saved; set only if it holds at least one business. */
  signalsAt?: string;
}

/** The saved time of the stored new-businesses list, only when that list is not empty: the copy
 *  is written with `savedAt` even for an empty fetch, and an empty copy has nothing to show. */
export const cachedSignalsAt = (stored: StoredSignals | null | undefined): string | undefined =>
  stored && stored.list.signals.length > 0 ? stored.savedAt : undefined;

/** First run or wiped phone: say why the lists are empty (also the Home's Today card). */
export const noLeadsYet = ({ signalsAt }: EmptyMirrorOptions = {}): HTMLDivElement => {
  const offline = getSyncStatus().state === 'offline';
  if (offline && signalsAt) {
    return empty(OFFLINE_SIGNALS_ONLY.title, OFFLINE_SIGNALS_ONLY.body(pacificDateTime(signalsAt)));
  }
  return empty(
    offline ? 'Offline and nothing cached yet.' : 'No leads yet.',
    offline
      ? 'Reconnect to pull your pipeline, or log a visit now — it will sync later.'
      : 'Log your first visit or pull from the server.',
  );
};

export const emptyMirror = (opts: EmptyMirrorOptions = {}): HTMLElement => h('div', {}, noLeadsYet(opts),
  h('div', { class: 'stack stack--center' },
    linkBtn('+ Log a visit', '#/log', { variant: 'primary' }),
    btn('Sync now', { variant: 'ghost', onClick: () => void runSync() })));
